var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 2.5h-1v-1c0-.55-.45-1-1-1s-1 .45-1 1v1h-8v-1c0-.55-.45-1-1-1s-1 .45-1 1v1h-1c-1.11 0-1.99.9-1.99 2l-.01 14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2m0 15c0 .55-.45 1-1 1h-12c-.55 0-1-.45-1-1v-10h14zm-12-8h2v2h-2zm4 0h2v2h-2zm4 0h2v2h-2z"
  })));
};
export default SvgCalendar;